import { LAYOUT_MODE_KEY } from "./LayoutModeContext";

// UI preferences that must survive the localStorage.clear() done on logout.
const isPreservedKey = (key) =>
  key === LAYOUT_MODE_KEY || key.startsWith("mysolon.ds.");

export const clearLocalStoragePreservingPrefs = () => {
  const kept = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && isPreservedKey(key)) kept.push([key, localStorage.getItem(key)]);
    }
  } catch {}
  localStorage.clear();
  kept.forEach(([key, value]) => {
    try {
      localStorage.setItem(key, value);
    } catch {}
  });
};
